/* 

Copyright© Celligence International, LLC - 2023

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained
access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.

*/

import { Typography, useTheme } from "@mui/material";
import { useLocation } from "react-router-dom";
import { UAParser } from "ua-parser-js";
import { Logo } from "morgan-sign";

import Constants from "../Constants";
import { UserWayAccessibilityMenu } from "../Components/UserWayAccessibilityMenu";
import DownloadForMobileSafari from "../Components/UtilityFunctions/DownloadForMobileSafari";
import { BrowserParser} from "../Components/UtilityFunctions/Parsers";

const FinishPage = () => {
  const isMobile = window.innerWidth < Constants.MIN_NON_MOBILE_WIDTH;
  const documentData = useLocation().state.data;
  const { browser } = UAParser(navigator.userAgent);
  const theme = useTheme()

  const handleDownload = async (e) => {
    e.preventDefault();
    const browserStr = BrowserParser(browser);
    const browserName = browserStr.split(" -")[0];
    if (browserName.toLowerCase().includes('safari')) {
      DownloadForMobileSafari(documentData)
    } else {
      const PDFdata = `data:application/pdf;base64,${documentData.documentBase64}`;
      const downloadLink = document.createElement("a");
      downloadLink.href = PDFdata;
      downloadLink.download = `signed-${documentData.docId}.pdf`;
      downloadLink.click();
    }
  };

  const handleMouseEnterOutlinedButton = (e) => {
    e.target.style.backgroundColor = theme.palette.primary.main;
    e.target.style.opacity = .75;
  }

  const handleMouseLeaveOutlinedButton = (e) => {
    e.target.style.backgroundColor = "";
    e.target.style.opacity = 1;
  }

  return (
    <div
      className="FinishPage"
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        textAlign: "center",
        alignItems: "center",
        backgroundColor: "#083f88",
        height: "100%",
        minHeight: "100vh",
      }}
    >
      <img src={Logo} alt="" style={{ marginTop: "1rem", maxWidth: "calc(100% - 2rem)", height: "auto", aspectRatio: "851/177" }} />
      <div
        style={{
          backgroundColor: "white",
          borderRadius: "10px",
          maxWidth: "500px",
          height: "fit-content",
          display: "flex",
          margin: "1rem",
          padding: "1rem 2rem",
          flexDirection: "column",
          justifyContent: "space-around",
          gap: "1rem",
        }}
      >
          <Typography
            variant="h4"
            sx={{
              display: "flex",
              flexDirection: "column",
              color: "#083f88",
              fontWeight: "bold",
              fontSize: `${isMobile ? "1.2em" : "1.5em"}`,
            }}
          >
            You have finished Ai-Signing! <br /> Thank You!
          </Typography>
          {"senderEmail" in documentData && documentData.senderEmail.length > 0 && (
            <Typography
              sx={{
                color: "#083f88",
              }}
            >
              The signed document has been emailed to you. Please look
              for an email from {documentData.senderEmail}.
            </Typography>
          )}
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <button
              onClick={(e) => handleDownload(e)}
              onMouseEnter={handleMouseEnterOutlinedButton}
              onMouseLeave={handleMouseLeaveOutlinedButton}
              style={{
                height: "40px",
                width: "40px",
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
                border: "solid 1px #083f88",
                borderRadius: "50%",
                backgroundColor: "transparent",
                cursor: "pointer",
                color: "#083F88"
              }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" height="30px" viewBox="0 -960 960 960" width="30px" fill="#083f88"><path d="M160-80v-80h640v80H160Zm320-160L200-600h160v-280h240v280h160L480-240Zm0-130 116-150h-76v-280h-80v280h-76l116 150Zm0-150Z"/></svg>
            </button>
          </div>
          {/* <img src={CheckMark} alt="" height="80vh" /> */}
          {/* <Typography
            variant="subtitle1"
            sx={{
              marginTop: "14%",
              fontFamily: "Segoe UI",
              fontSize: `${isMobile ? "0.9em" : "1em"}`,
            }}
          >
            You'll receive an email copy once everyone else has Ai-Signed.
          </Typography> */}
      </div>
      <UserWayAccessibilityMenu color="white" transparent={true} height={30} top={"95%"} left={"95%"} />
    </div>
  );
};

export default FinishPage;
